/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */
import { connectRouter } from 'connected-react-router/immutable';
import { combineReducers } from 'redux-immutable';
import defaultHistory from 'utils/history';

const rootReducer = ({ history = defaultHistory, injectedReducers = {} }) => combineReducers({
  router: connectRouter(history),
  ...injectedReducers,
});

export default rootReducer;
